exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.x-button {\n  color: red;\n  font-size: 25px;\n}\n.success-label {\n  word-break: break-all;\n}\n.mt-10 {\n  margin-top: 10px !important;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/views/DataOverride.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,gBAAgB;CACjB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,4BAA4B;CAC7B","file":"DataOverride.vue","sourcesContent":["\n.x-button {\n  color: red;\n  font-size: 25px;\n}\n.success-label {\n  word-break: break-all;\n}\n.mt-10 {\n  margin-top: 10px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af40a46a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DataOverride.vue
// module id = dG74
// module chunks = 1